import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BenefitsList',
  setup(__props) {

const { i18n } = useContext();

const benefits = computed(() => {
  return [
    {
      img: require(`@/assets/nodes/benefits-thumb-1.png`),
      header: i18n.t('components.nodes.benefitsList.own') as string,
      body: i18n.t('components.nodes.benefitsList.youDontNeed') as string,
    },
    {
      img: require(`@/assets/nodes/benefits-thumb-2.png`),
      header: i18n.t('components.nodes.benefitsList.empower') as string,
      body: i18n.t('components.nodes.benefitsList.supportProjects') as string,
    },
    {
      img: require(`@/assets/nodes/benefits-thumb-3.jpg`),
      header: i18n.t('components.nodes.benefitsList.earn') as string,
      body: i18n.t('components.nodes.benefitsList.seeAPilot') as string,
    },
  ];
});

return { __sfc: true,i18n, benefits }
}

})